import PropTypes from 'prop-types';
// @mui
import { Typography, Stack, Chip, Card, CardContent } from '@mui/material';
// components
import Image from '../../components/Image';
// constants
import { POSITION_OPTION_DICT } from '../../constants';
import {
  fKSTDateAbsoluteDuration
}  from '../../utils/formatTime';

// ------------------------------

CrewCard.propTypes = {
  crew: PropTypes.oneOfType([PropTypes.object]),
  onClick: PropTypes.func,
  isLoading: PropTypes.bool,
};


export default function CrewCard({ crew, onClick }) {
  return (
    <Card
      onClick={onClick}
      variant="outlined"
      sx={{
        padding: (theme) => theme.spacing(1),
        height: 260,
        borderRadius: 2,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        textAlign: 'center',
        alignItems: 'center',
        position: 'relative',
        '&:hover': {
          cursor: 'pointer',
          boxShadow: (theme) => theme.customShadows.z24,
        },
      }}
    >
      <Image
        visibleByDefault
        disabledEffect
        src={`https://spacey-dio-public.s3.ap-northeast-2.amazonaws.com/crewji/crewji_${crew.randomhash || Math.floor(Math.random() * 2) + 5}.png`}
        sx={{
          mt: 4,
          width: 64,
          height: 64,
        }}
      />
      <CardContent>
        <Stack spacing={1} sx={{ display: 'block' }}>
          <Stack
            direction="row"
            spacing={1}
            alignItems="center"
            justifyContent="center"
          >
            <Typography
              variant="subtitle1"
            >
              {crew.nickname || '크루'}
            </Typography>
          </Stack>
          <Typography
            variant="body2"
            sx={{ color: (theme) => theme.palette.grey[600] }}
          >
            {POSITION_OPTION_DICT[crew.position]}
          </Typography>
          {crew.min_start_date && crew.max_end_date && (
            <Chip
              variant="outlined"
              label={`${fKSTDateAbsoluteDuration(crew.min_start_date)} ~ ${fKSTDateAbsoluteDuration(crew.max_end_date)}`}
            />
          )}
        </Stack>
      </CardContent>
    </Card>
  );
};
